
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import { MstCommonCodeVO, MstOrderVO, RelClaimProductVO } from "@/views/biz/order/vo/order.vo";
import axios from "axios";
import { debounce } from "lodash-core";
import { Component, Prop, Vue } from "vue-property-decorator";
import { MstClaimVO } from "../mypage/vo/mypage.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";

//반품 상세 사유 필수 코드 리스트
const returnCodeList: string[] = ["008007","008008","008009"];

@Component({
  components: { CommonModalDialog }
})

export default class OrderClaimDetail extends Vue {
  @Prop() claimType!: string;
  @Prop() orderCd!: number;
  @Prop() claimCd!: number;

  order: MstOrderVO = {} as MstOrderVO;
  claim: MstClaimVO = {} as MstClaimVO;
  products = [] as Array<RelClaimProductVO>;

  commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>;

  isOpenedPopOver = false;
  isOpenedSuccessAlert = false;
  isOpendedNoticeAlert = false;

  // 취소/반품 공통코드
  claimCommCode: string = "" as string;

  // 팝오버에서 선택만 한 경우
  tmpCommCode = {} as MstCommonCodeVO;
  // 확인버튼을 누른 최종 취소사유 코드
  selectedCommonCode = {} as MstCommonCodeVO;


  // 신규임?
  get isNew(): boolean {
    return !this.claim.claimCd;
  }

  // 수정 가능?
  get isModify(): boolean {
    return this.isNew && this.claim.claimStatusCd != "004010";
  }

  // 취소냐 반품이냐
  get isCancel(): boolean {
    return "cancel" == this.claimType;
  }

  get isReturn(): boolean {
    return !this.isCancel;
  }

  // 클레임 수량이 0보다 큰 상품 목록
  get claimProducts() {
    return this.products.filter((v) => v.claimCount > 0);
  }

  // 부분취소 가능?
  get canCancelPartly() {
    if (this.isCancel == false) {
      return true;
    }
    return !(this.order.firstPurchaseOrder || this.order.paymentDscPrice || this.order.couponCd);
  }

  // 상품금액 합계
  get returnProductPriceSum(): number {
    let result = 0;
    this.products.forEach((product) => {
      if (!product.claimCount) {
        return;
      }

      // 신청중이면
      if (product.orderCount == product.claimCount) {
        result += product.productClaimPrice || product.productPaymentPrice;
      } else {
        result += (product.salePrice - product.gradeDiscountPrice) * product.claimCount;
      }
    });
    return result;
  }

  // 반품 시 이미지 등록 필수( 오배송/ 제품불량 )
  checkRequiredReturnImage(): boolean{
    if (this.claimType == "return" && !this.claim.returnImgFileUrl && (this.claim.claimReasonCd == "008009"|| this.claim.claimReasonCd == "008008")) {
      // 사진을 업로드 해주세요.
       alert(this.$t("claim.a0009"));
       return true;
    }
    return false;
  }

  // 주문 취소 신청
  orderClaimApply() {
    // 취소/반품 수량이 올바르지 않습니다. (결제대기 상태 건은 제외)
    if (!this.claimProducts.length) {
      return alert(this.$t("claim.a0003"));
    }

    for (const product of this.claimProducts) {
      // 취소/반품 수량이 올바르지 않습니다. (결제대기 상태 건은 제외)
      if (product.claimCount > product.orderCount) {
        return alert(this.$t("claim.a0003"));
      }
    }

    // 취소 사유를 선택해주세요.
    if (!this.claim.claimReasonCd) {
      return alert(this.$t("claim.a0001"));
    }

    // 반품사유는 10자 이상 500자 이하로 입력해주세요. (취소는 안해두됨) 변경일자 (2024/06/20)
    if(returnCodeList.indexOf(this.claim.claimReasonCd)>-1){
      if (!this.claim.claimReasonTxt || (this.claim.claimReasonTxt.length < 10 || this.claim.claimReasonTxt.length > 500)) {
        return alert(this.$t("t0294"));
      }
    }
 
    
    // 반품 시 이미지 등록 체크 메소드
    if(this.checkRequiredReturnImage()){
      return;
    }
  
    // 신청을 하시겠습니까?
    if (confirm(this.$t("claim.c0001").toString()) == false) {
      return;
    }

    axios.post(`/mypage/order/claim`, { claim: this.claim, claimProducts: this.claimProducts }).then(
      () => {
        this.isOpenedSuccessAlert = true;

        CommonUtils.sendCommonEventLogs(this, Constants.CUSTOM_ORDER_CLAIM, { orderCd: this.claim.orderCd });
      },
      () => {
        alert(this.$t("common.a0001"));
      }
    );
  }

  // 취소 수량
  getCancelQtys(product: RelClaimProductVO): Array<number> {
    if(this.isReturn || !product.memberCouponSeq) {
      return Array.from({length: product.orderCount}, (_, i) => i + 1); // 5 -> [1,2,3,4,5]
    }
    return [product.orderCount];
  }


  // 취소 사유 확인 버튼(확정)
  changeCancelReason() {
    this.selectedCommonCode = this.tmpCommCode;
    for (const i in this.products) {
      this.$set(this.claim, "claimReasonCd", this.selectedCommonCode.commCd);
      this.$set(this.claim, "claimReasonNm", this.tmpCommCode.commNm);
    }
    this.isOpendedNoticeAlert = this.claim.claimReasonCd == '008010';
  }

  // 이미지 사진 업로드 후 저장된 값 리턴
  uploadFile(e) {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    formData.append("bizType", "returnApply");
    axios.post("/common/file/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => {
      this.$set(this.claim, "returnImgFileUrl", r.data[0].url);
      this.$set(this.claim, "returnImgFileCd", r.data[0].fileCd);
    });
  }

  // 파일 삭제
  deleteFile() {
    Vue.delete(this.claim, "returnImgFileCd");
    Vue.delete(this.claim, "returnImgFileUrl");
  }

  // 클레임 신청 완료 후 처리
  success() {
    this.isOpenedSuccessAlert = false;
    this.$router.push({ name: "OrderClaimInventory" });
  }

  // 반품 타입에 맞은 placeholder 문구 리턴하기
  getPlaceHolder(): string{
    if(this.claim.claimReasonCd == "008008"){
      return "t0294-1";
    }
    if(this.claim.claimReasonCd == "008009"){
      return "t0294-2";
    }

    if(this.claim.claimReasonCd == "008007"){
      return "t0294-3";
    }
    return "t0294";
  }

  createClaimReasons(): void {
    // 004061: 취소접수, 004070: 반품접수
    // 취소 코드 : 007, 반품 코드 : 008
    switch (this.claimType) {
      case "cancel":
        this.isNew && (this.claim.claimStatusCd = "004061");
        for (const i in this.products) {
          this.claimCommCode = "007";
        }
        break;
      case "return":
        this.isNew && (this.claim.claimStatusCd = "004070");
        for (const i in this.products) {
          this.claimCommCode = "008";
        }
        break;
    }

    axios.get(`/common/code/codes/${this.claimCommCode}`).then((r) => {
      this.commonCodes = r.data;
    });
  }

  // 예상환불액 계산하기
  calcClaim() {
    axios.post("mypage/order/claim/refund-amount", { claim: this.claim, claimProducts: this.products }).then((r) => {
      this.$set(this.claim, "returnDeliveryFee", r.data.returnDeliveryFee);
      this.$set(this.claim, "returnHsPrice", r.data.returnHsPrice);
      this.$set(this.claim, "returnPoint", r.data.returnPoint);
      this.$set(this.claim, "returnPaymentPrice", r.data.returnPaymentPrice);
      this.$set(this.claim, "returnOrderCouponDiscountPrice", r.data.returnOrderCouponDiscountPrice);
    });
  }

  changeClaimCount = debounce(this.changeClaimCount2, 200);
  changeClaimCount2() {
    this.calcClaim();
  }

  // init
  created() {
    axios.get(`/mypage/order/claim`, { params: { orderCd: this.orderCd, claimCd: this.claimCd } }).then((result) => {
      // 처리중인 클레임이 있으면
      if (result.data.claim) {
        this.claim = result.data.claim;
      } else {
        this.claim = {} as MstClaimVO;
        this.claim.orderCd = this.orderCd;
      }

      this.$nextTick(() => {
        if (!this.isNew && !this.claimCd) {
          // 취소/반품 처리중인 주문입니다.
          alert(this.$t("claim.a0010"));   
        }
      });

      this.products = result.data.products;
      this.order = result.data.order;

      // 배송 준비중 이상의 상태코드인지 체크 로직 (취소일때)
      if(!this.isReturn){
        const isShipped = this.products.flatMap(val =>val).filter(val=> val.orderStatusCd > '004022');

        if(this.isNew && isShipped.length != 0 && isShipped.length == this.products.length ){
          this.$nextTick(() => {
              alert(this.$t("claim.a0011")); 
            this.$router.push({name:'Mypage'});
          })
        }
      }

      // 신규 클레임
      if (this.isNew) {
        // claimCount 초기화
        this.products.forEach((product) => {
          if (this.isReturn) {
            // 반품임?
            product.claimCount = product.orderCount;
            this.changeClaimCount();
            return;
          }
          // 부분 취소 가능?
          if (this.canCancelPartly) {
            product.claimCount = 0;
          } else {
            product.claimCount = product.orderCount;
          }
        });
        // 전체취소면 환불액 계산해줌
        if (!this.canCancelPartly) {
          this.calcClaim();
        }
      }

      this.createClaimReasons();
    });
  }
}
